import React from "react";
import "./affirm.scss"
import { Header } from "components/header";
import { PageHeading } from "components/pageHeading";
import { Button } from "components/button";
import { navigate } from "@reach/router";

var discountName, billingFirst, billingLast, billingAddress1, billingAddress2, billingCity, billingState, billingEmail, billingZip, billingPhone, totalRaw, total, productName, unitPriceRaw, unitPrice, productQuantity, taxRaw, tax, shippingRaw, shipping, discountRaw, discount, calculatedTotal, calculatedSubtotal;
declare var window: any;
export interface AffirmProps {
    path?: string;
}

export interface AffirmState {
	leadDetails:any;
}

class Affirm extends React.Component<AffirmProps, AffirmState> {
    constructor(props: AffirmProps) {
        super(props);
		this.state = {
			leadDetails: JSON.parse(localStorage.getItem("leadDetails") || '{}')
		};
    }

    checkoutHandler() {
        billingFirst = "Ben";
		billingLast = "Mo";
		billingAddress1 = "225 Bush St";
		billingAddress2 = "Floor 16";
		billingCity = "San Francisco";
		billingState = "CA";
		billingEmail = "jdas@in.allmysons.com";
		billingZip = "94104";
		billingPhone = "9253236612";
		productName = "Best Thing Ever";
		productQuantity = "1";
		unitPrice = "100.00";
		tax = "4000";
		shipping = "2000";
		discount = "100";
		total = "4001";
		discountName = "PROMO123";

		var checkoutObject11 = {

			"config": {
				"financial_product_key": "05Q7LVUFMXR5THZW",
				"public_api_key": "WZNSS7RG54X0YUJH",
			},

			"merchant": {
				"user_cancel_url": "http://localhost:3000/affirmCancellation",
				"user_confirmation_url": "http://localhost:3000/affirmThankyou",
				"user_confirmation_url_action": "GET",
			},

			"items": [{
				"display_name": "",
				"sku": "",
				"unit_price": 0,
				"qty": 0,
				"item_image_url": "",
				"item_url": ""
			}],
			//"discounts": {
			//	"ABC1234": {
			//		"discount_amount": 500,
			//		"discount_display_name": "Best discount"
			//	},
			//	"DEF5678": {
			//		"discount_amount": 1000,
			//		"discount_display_name": "Worst discount"
			//	}
			//},
			//"order_id": '6209495_1',
			"metadata": {
				"shipping_type": "UPS Ground",
				"CustomerID": "6531461",
				"EstimatorID": "1220",
				"MoveDailySheetID": "6209495",
				"MoveID": "6433381",
				"OrderID": "6209495_1",
					"mode": "modal"
			},
			"shipping": {
				"name": {
					"first": billingFirst,
					"last": billingLast
				},
				"address": {
					"line1": billingAddress1,
					"line2": billingAddress2,
					"city": billingCity,
					"state": billingState,
					"zipcode": billingZip
				},
				"phone_number": billingPhone,
				"email": billingEmail,
			},
			"billing": {
				"name": {
					"first": billingFirst,
					"last": billingLast
				},
				"address": {
					"line1": billingAddress1,
					"line2": billingAddress2,
					"city": billingCity,
					"state": billingState,
					"zipcode": billingZip
				},
				"phone_number": billingPhone,
				"email": billingEmail,
			},
			"shipping_amount": shipping,
			"tax_amount": tax,
			"total": total
		};

		var checkoutObject = {

			"config": {
				"financial_product_key": this.state.leadDetails.financial_product_key,
				"public_api_key": this.state.leadDetails.public_api_key,
			},

			"merchant": {
				// "user_cancel_url": "http://localhost:3000/affirmCancellation",
				 //"user_confirmation_url": "http://localhost:3000/affirmThankyou",
				 //"user_confirmation_url_action": "GET",
// PRODUCTION
				"user_cancel_url": this.state.leadDetails.user_cancel_url,
				"user_confirmation_url": this.state.leadDetails.user_confirmation_url,
				"user_confirmation_url_action": this.state.leadDetails.user_confirmation_url_action,

	
			},
			"items": [{
				"display_name": "",
				"sku": "",
				"unit_price": 0,
				"qty": 0,
				"item_image_url": "",
				"item_url": ""
			}],
			"metadata": {
				"shipping_type": this.state.leadDetails.shipping_type,
				"CustomerID": this.state.leadDetails.customerID,
				"EstimatorID": this.state.leadDetails.estimatorID,
				"MoveDailySheetID":this.state.leadDetails.moveDailySheetID,
				"MoveID": this.state.leadDetails.moveID,
				"OrderID": this.state.leadDetails.orderID,
				"redirectURL":this.state.leadDetails.redirectURL,
				"mode": "modal",
			},
			"shipping": {
				"name": {
					"first": this.state.leadDetails.shippingFirstName,
					"last": this.state.leadDetails.shippingLastName
				},
				"address": {
					"line1": this.state.leadDetails.shippingAddLine1,
					"line2": this.state.leadDetails.shippingAddLine2,
					"city": this.state.leadDetails.shippingAddCity,
					"state": this.state.leadDetails.shippingAddState,
					"zipcode": this.state.leadDetails.shippingAddZipCode
				},
				"phone_number": this.state.leadDetails.shippingPhone,
				"email": this.state.leadDetails.shippingEmail,
			},
			"billing": {
				"name": {
					"first": this.state.leadDetails.billingFirstName,
					"last": this.state.leadDetails.billingLastName,
				},
				"address": {
					"line1": this.state.leadDetails.billingAddLine1,
					"line2": this.state.leadDetails.billingAddLine2,
					"city": this.state.leadDetails.billingAddCity,
					"state": this.state.leadDetails.billingAddState,
					"zipcode": this.state.leadDetails.billingAddZipCode
				},
				"phone_number": this.state.leadDetails.billingPhone,
				"email": this.state.leadDetails.billingEmail,
			},
			"shipping_amount": this.state.leadDetails.shipping_amount,
			"tax_amount": this.state.leadDetails.tax_amount,
			"total": this.state.leadDetails.total
		};

		
		//debugger;
		console.log(JSON.stringify(checkoutObject));
		window.affirm.checkout(checkoutObject);
		window.affirm.checkout.post();
    }
    getStarted(){
        //alert(window.affirm);
    }
    render() {
       // alert( window.affirm);
        this.checkoutHandler();
        return (
            <div className="home-container" onClick={this.getStarted}>
                {/* <Header
                    rightIcon={"phone"}
                    rightText={"Call Us"}
                /> */}
				 <Header />
                <div className="home-btn">
                    Loading please wait...
                </div>
            </div>
        );
    }
}

export default Affirm;